import {db} from './firebase'

// firebase collections
const dreamsCollection = db.collection('dreams')
// const goalsCollection = db.collection('goals')
// const subgoalsCollection = db.collection('subgoals')
const usersCollection = db.collection('users')
const storiesCollection = db.collection('stories')
const tipsCollection = db.collection('tips')
const routinesCollection = db.collection('routines')
const tasksCollection = db.collection('tasks')
const goalsCollection = db.collection('goals2')
const reviewsCollection = db.collection('reviews')
const lessonsCollection = db.collection('lessons')
const notificationsCollection = db.collection('notifications')
const settingsCollection = db.collection('settings')

export {
  dreamsCollection,
  goalsCollection,
  usersCollection,
  storiesCollection,
  tipsCollection,
  routinesCollection,
  tasksCollection,
  reviewsCollection,
  lessonsCollection,
  notificationsCollection,
  settingsCollection
}
